/* eslint-disable no-console */
import { toast } from 'react-toastify';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';
import * as actions from './actions';

import * as types from './types';

/**
 * ---------------------------------------------------
 *  GET INDICADORES DO PAINEL GERAL
 * ---------------------------------------------------
 */

export function* getIndicatorsPg({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(
      api.get,
      `indicators/institution/${id}?limit=100&offset=0`
    );

    yield put(
      actions.getIndicatorsPgSuccess({
        indicatorsPgData: response?.data,
      })
    );
  } catch (error) {
    yield put(
      actions.getIndicatorsPgFailure({
        errorData: error?.response?.data,
      })
    );
  }
}

/**
 * ---------------------------------------------------
 *  ATIVAR - INDICADOR DO PAINEL GERAL
 * ---------------------------------------------------
 */

export function* activeIndicatorsPg({ payload }) {
  try {
    const { idIndicador, idInstituicao, datas } = payload;

    const response = yield call(
      api.put,
      `indicators/${idIndicador}/institution/${idInstituicao}/activate`,
      datas
    );

    if (response.status === 200) {
      yield put(actions.getIndicatorsPgRequest({ id: idInstituicao }));
    }
  } catch (error) {
    yield put(
      actions.activeIndicatorsPgFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error('Ocorreu um erro ao ativar o indicador.', {
      autoClose: 5000,
    });
  }
}

/**
 * ---------------------------------------------------
 *  INATIVAR - INDICADOR DO PAINEL GERAL
 * ---------------------------------------------------
 */

export function* inactiveIndicatorsPg({ payload }) {
  try {
    const { idIndicador, idInstituicao, datas } = payload;

    const response = yield call(
      api.put,
      `indicators/${idIndicador}/institution/${idInstituicao}/inactivate`,
      datas
    );

    if (response.status === 200) {
      yield put(actions.getIndicatorsPgRequest({ id: idInstituicao }));
    }
  } catch (error) {
    yield put(
      actions.inactiveIndicatorsPgFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error('Ocorreu um erro ao inativar o indicador.', {
      autoClose: 5000,
    });
  }
}

/**
 * ---------------------------------------------------
 *  ATIVAR - ESTRATIFICACAO
 * ---------------------------------------------------
 */

export function* activeEstrat({ payload }) {
  try {
    const { id, idInstituicao, datas } = payload;

    const response = yield call(
      api.put,
      `indicators/stratification/${id}/institution/${idInstituicao}/activate`,
      datas
    );

    toast.success('Estratificação ativada com sucesso.', {
      autoClose: 5000,
    });

    if (response.status === 200) {
      yield put(actions.getIndicatorsPgRequest({ id: idInstituicao }));
    }
  } catch (error) {
    yield put(
      actions.activeEstratFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error('Ocorreu um erro ao ativar o indicador.', {
      autoClose: 5000,
    });
  }
}

/**
 * ---------------------------------------------------
 *  INATIVAR - ESTRATIFICACAO
 * ---------------------------------------------------
 */

export function* inactiveEstrat({ payload }) {
  try {
    const { id, idInstituicao, datas } = payload;

    const response = yield call(
      api.put,
      `indicators/stratification/${id}/institution/${idInstituicao}/inactivate`,
      datas
    );

    toast.success('Estratificação inativada com sucesso.', {
      autoClose: 5000,
    });

    if (response.status === 200) {
      yield put(actions.getIndicatorsPgRequest({ id: idInstituicao }));
    }
  } catch (error) {
    yield put(
      actions.inactiveEstratFailure({
        errorData: error?.response?.data,
      })
    );

    toast.error('Ocorreu um erro ao inativar o indicador.', {
      autoClose: 5000,
    });
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `${token}`;
  }
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest(types.GET_INDICATORS_PG_REQUEST, getIndicatorsPg),
  takeLatest(types.ACTIVE_INDICATORS_PG_REQUEST, activeIndicatorsPg),
  takeLatest(types.INACTIVE_INDICATORS_PG_REQUEST, inactiveIndicatorsPg),
  takeLatest(types.ACTIVE_ESTRAT_REQUEST, activeEstrat),
  takeLatest(types.INACTIVE_ESTRAT_REQUEST, inactiveEstrat),
]);
